import { useState } from "react";
import { useLineEvents } from "@/features/lines/hooks";
import type { ActionKind, ActiveRun } from "./types";

export function useOperationalEntryState(lineId: string, activeRun: ActiveRun | null | undefined) {
  const [openAction, setOpenAction] = useState<ActionKind | null>(null);
  const [justifyEventId, setJustifyEventId] = useState<string | null>(null);
  const eventsQuery = useLineEvents(lineId, 20);
  const events = eventsQuery.data ?? [];

  // NODATA também é justificável, não só STOP.
  const pendingEvents = events.filter(
    (e) => (e.type === "STOP" || e.type === "NODATA") && e.reasonStatus === "PENDING"
  );
  const isPaused = activeRun?.status === "PAUSED";

  return {
    openAction,
    setOpenAction,
    closeAction: () => setOpenAction(null),
    justifyEventId,
    setJustifyEventId,
    pendingEvents,
    isPaused,
    // Em erro, `events` cai para [] e "Justificar evento" some silenciosamente;
    // consumidores devem mostrar isError/error em vez de tratar como "sem pendências".
    isError: eventsQuery.isError,
    error: eventsQuery.error,
    refetchEvents: eventsQuery.refetch,
  };
}
